/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconJob extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "JobIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' viewbox="0 0 64.27 64" xmlns="http://www.w3.org/2000/svg"><g><g><rect height="64" fill="none" width="64"></rect><polyline points="47.63 2.74 4.5 5.36 7.89 61.26 51.02 58.64 47.63 2.74" fill="#d2cbcf"></polyline><path d="M48.75,21.22,49,24.82a10.38,10.38,0,0,1,5.36,9.1h0A10.4,10.4,0,0,1,50,42.3L50.25,46a13.74,13.74,0,0,0,2-1.28l9.07,9.7,3-3-9.69-9a13.53,13.53,0,0,0,2.94-8.44,13.69,13.69,0,0,0-8.77-12.7" fill="#909090"></path><path d="M43.92,20.32A13.6,13.6,0,1,0,50.25,46L50,42.3a10.36,10.36,0,0,1-16.5-8.38h0A10.41,10.41,0,0,1,49,24.82l-.22-3.59a13.35,13.35,0,0,0-4.83-.9" fill="#8a8789"></path><path d="M49,24.82,50,42.3A10.37,10.37,0,0,0,49,24.82" fill="#d7d7d7"></path><path d="M43.92,23.52A10.4,10.4,0,1,0,50,42.3L49,24.82a10.38,10.38,0,0,0-5-1.3" fill="#c8c2c5"></path></g></g></svg>
    `;
}
